import { FunctionComponent, memo } from 'react';
import { FeedCardProps, FeedCardTeaser } from '../../../shared';

export const FeedCardArticle: FunctionComponent<FeedCardProps> = memo((props) => (
  <FeedCardTeaser {...props} />
));
